import { LogType } from './LogType';

export interface ILogStyle {
    // game stuff

    /**
     * For determining what browser-level log type to use (e.g. normal, error, warning)
     */
    logAs?: LogType;

    /**
     * Whether to log the full stack trace to the console below the log
     */
    logWithStackTrace?: boolean;

    /**
     * Whether to log partial stack trace to where the log was called
     */
    logWithLocation?: boolean;

    // css properties
    "background-color"?: string;
    "color"?: string;
    "font-size"?: string;
}

export enum LogStyles {
    /**
     * Default style to apply if none others are provided
     */
    DEFAULT,

    /**
     * When you need a certain log to be visible in a sea of other logs
     */
    VISIBLE,

    /**
     * When you need something to be *really* visible.
     */
    HYPER_VISIBLE,

    /**
     * Default settings for logging warnings
     */
    WARNING,

    /**
     * Default settings for logging errors
     */
    ERROR,
}

const _LogStyles: {[key: number]: ILogStyle} = {
    [LogStyles.DEFAULT]: {},
    [LogStyles.WARNING]: {
        logAs: LogType.WARNING
    },
    [LogStyles.ERROR]: {
        logAs: LogType.ERROR
    },
    [LogStyles.VISIBLE]: {
        "background-color": "orange",
        "color": "black",
        "font-size": "12px",
    },
    [LogStyles.HYPER_VISIBLE]: {
        logWithStackTrace: true,
        "background-color": "magenta",
        "color": "white",
    }
}

export function getLogStyle(_style: LogStyles): ILogStyle {
    return _LogStyles[_style];
}

export function convertLogStyleToString(_style: ILogStyle): string {
    const keys: Array<keyof ILogStyle> =
        (
            Object.keys(_style).filter((e) => _style.hasOwnProperty(e))
        ) as Array<keyof ILogStyle>;
    let retVal: string = "";

    for(let i: number = 0; i < keys.length; i++) {
        retVal += `${keys[i]}:${_style[keys[i] as keyof ILogStyle]};`;
    }

    return retVal;
}
